<template>
    <div id="adminhome">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        <div class="sideNav" :style="{ width: navWidth + 'px' }">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                </div>
            </div>
            <div v-if="navMenuVisible" class="navsidecontent">
                <div class="navtitle noborder">
                    Gérer les biens et demandes
                </div>
                <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                    Créer un nouveau bien
                </div>
                <div v-on:click="goToBuildingPage" class="navsubtitle">
                    Consulter/Modifier les biens et demandes
                </div>
                <div class="navtitle">
                    Plannings
                </div>
                <div v-on:click="goToPlanningPage" class="navsubtitle">
                    Consulter/Modifier les plannings
                </div>
                <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                    Fiches horaires
                </div>
                <div class="navtitle">
                    Groupes
                </div>
                <div v-on:click="goToNewGroupPage" class="navsubtitle">
                    Ajouter un groupe
                </div>
                <div v-on:click="goToAllGroupPage" class="navsubtitle">
                    Voir/Modifier les groupes
                </div>
                <div class="navtitle">
                    Utilisateurs
                </div>
                <div v-on:click="goToNewUserPage" class="navsubtitle">
                    Ajouter un utilisateur
                </div>
                <div v-on:click="goToAllUserPage" class="navsubtitle">
                    Voir/Modifier les utilisateurs
                </div>
                <div v-on:click="logout()" class="navtitle logout">
                    Déconnexion
                </div>
            </div>
        </div>
        </nav>
        <h1>À traiter</h1>
        <button v-on:click="isInvoiceHide = !isInvoiceHide" class="btnAccordion">
            <font-awesome-icon v-if="isInvoiceHide" icon="angle-up" />
            <font-awesome-icon v-if="!isInvoiceHide" icon="angle-down" />
            &nbsp;&nbsp;Demandes en attente de facture ({{invoiceData.length}})
        </button>
        <div v-if="!isInvoiceHide">
            <div class="notifList" v-for="(item, index) in invoiceData" :key="index">
                <div class="divCard">
                    <span class="spanCard notif">
                        {{ item.address.streetNb + " " +item.address.streetName}}&nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;&nbsp;{{item.type}}
                    </span>
                    <button v-on:click="goToInvoicePage(item.name)" class="btnCard notifBtn"><font-awesome-icon icon="chevron-right" /></button>
                </div>
            </div>
        </div>
        <hr>
        <button v-on:click="isInvoiceHide = !isInvoiceHide" class="btnAccordion">
            <font-awesome-icon v-if="isInvoiceHide" icon="angle-up" />
            <font-awesome-icon v-if="!isInvoiceHide" icon="angle-down" />
            &nbsp;&nbsp;Demandes en attente de devis ({{quotationData.length}})
        </button>
        <div v-if="!isInvoiceHide">
            <div class="notifList" v-for="(item, index) in quotationData" :key="index">
                <div class="divCard">
                    <span class="spanCard notif">
                        {{ item.address.streetNb + " " +item.address.streetName}}&nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;&nbsp;{{item.type}}
                    </span>
                    <button v-on:click="goToQuotationSigPage(item.name)" class="btnCard notifBtn"><font-awesome-icon icon="chevron-right" /></button>
                </div>
            </div>
        </div>
        <hr>
        <button v-on:click="isQuotationHide = !isQuotationHide" class="btnAccordion">
            <font-awesome-icon v-if="isQuotationHide" icon="angle-up" />
            <font-awesome-icon v-if="!isQuotationHide" icon="angle-down" />
            &nbsp;&nbsp;Demandes en attente de rendez-vous ({{rdvData.length}})
        </button>
        <div  v-if="!isQuotationHide">
            <div class="notifList" v-for="(item, index) in rdvData" :key="index">
                <div class="divCard">
                    <span class="spanCard notif">
                        {{ item.address.streetNb + " " +item.address.streetName}}&nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;&nbsp;{{item.type}}
                    </span>
                    <button v-on:click="goToInquiryPage(item.name)" class="btnCard notifBtn"><font-awesome-icon icon="chevron-right" /></button>
                </div>
            </div>
        </div>
        <hr>
        <button v-on:click="isSignatureHide = !isSignatureHide" class="btnAccordion">
            <font-awesome-icon v-if="isSignatureHide" icon="angle-up" />
            <font-awesome-icon v-if="!isSignatureHide" icon="angle-down" />
            &nbsp;&nbsp;Devis signé en attente de validation ({{signatureData.length}})
        </button>
        <div  v-if="!isSignatureHide">
            <div class="notifList" v-for="(item, index) in signatureData" :key="index">
                <div class="divCard">
                    <span class="spanCard notif">
                        {{ item.address.streetNb + " " +item.address.streetName}}&nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;&nbsp;{{item.type}}
                    </span>
                    <button v-on:click="goToQuotationSigPage(item.name)" class="btnCard notifBtn"><font-awesome-icon icon="chevron-right" /></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Adminhome',
        data() {
            return {
                buildings : [],
                Name:"Client",
                navMenuVisible: false,
                navWidth: 0,
                isInvoiceHide: false,
                isQuotationHide: false,
                isSignatureHide: false,
                quotationData: [],
                invoiceData:[],
                rdvData: [],
                quotationDataLink: [],
                invoiceDataLink: [],
                signatureData: [],
                signatureDataLink: [],
                rdvDataLink: []
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('history');
                this.$cookie.delete('historyQuery');
                this.$router.replace({ name: "login" });
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            async fillInvoiceLink(name){
                var nameInq = name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq);
                this.invoiceDataLink.push({name:name, id:response.data.inquiry._id});
            },
            async fillQuotationSigLink(name){
                var nameInq = name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq);
                this.signatureDataLink.push({name:name, id:response.data.inquiry.quotation._id});
            },
            async fillQuotationUnSigLink(name){
                var nameInq = name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq);
                this.signatureDataLink.push({name:name, id:response.data.inquiry._id});
            },
            async fillQuotationLink(name){
                var nameInq = name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq);
                this.rdvDataLink.push({name:name, id:response.data.inquiry._id});
            },
            goToInvoicePage(name){
                for(var i=0; i<this.invoiceDataLink.length; i++){
                    if(this.invoiceDataLink[i].name === name){
                        var arrHist = ['adminhome'];
                        var strHist = JSON.stringify(arrHist);
                        this.$cookie.set('history', strHist);
                        var arrQuery = [''];
                        var strQuery = JSON.stringify(arrQuery);
                        this.$cookie.set('historyQuery', strQuery);
                        this.$router.replace({ name: "invoiceadmin", query: {name: this.invoiceDataLink[i].id, id:name }});
                    }
                }
            },
            goToQuotationPage(name){
                for(var i=0; i<this.rdvDataLink.length; i++){
                    if(this.rdvDataLink[i].name === name){
                        var arrHist = ['adminhome'];
                        var strHist = JSON.stringify(arrHist);
                        this.$cookie.set('history', strHist);
                        var arrQuery = [''];
                        var strQuery = JSON.stringify(arrQuery);
                        this.$cookie.set('historyQuery', strQuery);
                        this.$router.replace({ name: "quotationadmin", query: {name: this.rdvDataLink[i].id, id:name}});
                    }
                }
            },
            goToInquiryPage(name){
                for(var i=0; i<this.rdvDataLink.length; i++){
                    if(this.rdvDataLink[i].name === name){
                        var arrHist = ['adminhome'];
                        var strHist = JSON.stringify(arrHist);
                        this.$cookie.set('history', strHist);
                        var arrQuery = [''];
                        var strQuery = JSON.stringify(arrQuery);
                        this.$cookie.set('historyQuery', strQuery);
                        this.$router.replace({ name: "inquiryadmin", query: {name:name}});
                    }
                }
            },
            goToQuotationSigPage(name){
                for(var i=0; i<this.signatureDataLink.length; i++){
                    if(this.signatureDataLink[i].name === name){
                        var arrHist = ['adminhome'];
                        var strHist = JSON.stringify(arrHist);
                        this.$cookie.set('history', strHist);
                        var arrQuery = [''];
                        var strQuery = JSON.stringify(arrQuery);
                        this.$cookie.set('historyQuery', strQuery);
                        this.$router.replace({ name: "quotationadmin", query: {name: this.signatureDataLink[i].id, id:name}});
                    }
                }
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                location.reload();
            },
            goToBuildingPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "newbuilding"});
            },
            goToAllUserPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "alluser"});
            },
            goToAllGroupPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "newgroup"});
            },
            goToTimeSheetPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "timesheet"});
            },
            goToNewUserPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "newuser"});
            },
            goToPlanningPage(){
                var arrHist = ['adminhome'];
                var strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);
                var arrQuery = [''];
                var strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                this.$router.replace({ name: "planningadmin"});
            },
            getStatus(i){
                for(var j=0; j<this.filteredBuilding[i].inquiry.length;j++){
                    if(this.filteredBuilding[i].inquiry[j].status === "en attente de devis" || this.filteredBuilding[i].inquiry[j].status === "en attente de rendez-vous"){
                        return true;
                    }
                }
                return false;                
            },
            getStatusNumber(i){
                var nb = 0;
                for(var j=0; j<this.filteredBuilding[i].inquiry.length;j++){
                    if(this.filteredBuilding[i].inquiry[j].status === "en attente de devis" || this.filteredBuilding[i].inquiry[j].status === "en attente de rendez-vous"){
                        nb++;
                    }
                }
                return nb;                
            },
            dataUrl(i){
                return 'data:'+this.buildings[i].picture.img.contentType+';base64,' + btoa(
                    new Uint8Array(this.buildings[i].picture.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") ){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getBuildings();
                }
            },
            async getBuildings(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building');
                
                if(response.data.buildings){
                    this.buildings = response.data.buildings;
                    for(var j=0; j<this.buildings.length; j++){
                        this.buildings[j].searchData = this.buildings[j].buildingAddress.firstName +" "+
                                                    this.buildings[j].buildingAddress.lastName +" "+
                                                    this.buildings[j].buildingAddress.streetNb +" "+
                                                    this.buildings[j].buildingAddress.streetName +" "+
                                                    this.buildings[j].buildingAddress.postalCode +" "+
                                                    this.buildings[j].buildingAddress.city;
                        for(var i=0; i<this.buildings[j].inquiry.length; i++){
                            if(this.buildings[j].inquiry[i].status === "en attente de rendez-vous"){
                                this.rdvData.push({
                                                            address:this.buildings[j].buildingAddress, 
                                                            type:this.buildings[j].inquiry[i].type, 
                                                            name:this.buildings[j].inquiry[i].name
                                                        });
                                console.log(this.buildings[j].inquiry[i].name)
                                this.fillQuotationLink(this.buildings[j].inquiry[i].name);
                            }
                            if(this.buildings[j].inquiry[i].status === "En attente de vérification"){
                                this.signatureData.push({
                                                            address:this.buildings[j].buildingAddress, 
                                                            type:this.buildings[j].inquiry[i].type, 
                                                            name:this.buildings[j].inquiry[i].name
                                                        });
                                console.log("building : "+this.buildings[j].name)
                                this.fillQuotationSigLink(this.buildings[j].inquiry[i].name);
                            }                            
                            if(this.buildings[j].inquiry[i].status === "en attente de devis"){
                                this.quotationData.push({
                                                        address:this.buildings[j].buildingAddress,
                                                        type:this.buildings[j].inquiry[i].type,
                                                        name:this.buildings[j].inquiry[i].name
                                                    });
                                this.fillQuotationUnSigLink(this.buildings[j].inquiry[i].name);
                            }                         
                            if(this.buildings[j].inquiry[i].status === "en attente de facture"){
                                this.invoiceData.push({
                                                        address:this.buildings[j].buildingAddress,
                                                        type:this.buildings[j].inquiry[i].type,
                                                        name:this.buildings[j].inquiry[i].name
                                                    });
                                this.fillInvoiceLink(this.buildings[j].inquiry[i].name);
                            }
                        }
                    }
                }
            }
        },
        mounted(){
            this.getCookies();
        },
        computed: {
            filteredBuilding() {
                return this.buildings.filter(building => {
                    return building.searchData.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #adminhome {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 85px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 550;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }
    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }
    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    #circleRed {
        width: 16px;
        height: 16px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: -6px;
        right: 67px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        color:white;
        text-align: center;
        font-size:13px;
        vertical-align: middle;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    #logout{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
    .card{
        font-family: 'BenchNine', sans-serif;
        margin:10px;
        margin-bottom:10px;
        background-color: #F0F0F0;
        display: inline-block;
        position: relative;
    }
    .imgCard{
        border-bottom: 2px solid;
        border-color:#1ce83e;
        width:150px;
        height: 75px;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 5%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 13px;
    }
    .notif{
        padding-left: 15px;
        font-size: 15px;
    }
    .notifBtn{
        right: 20px;
    }
    .search-wrapper {
        position: relative;
        label {
          position: absolute;
          width: calc(100% - (24px + 2px));
          font-size: 15px;
          color: rgba(0,0,0,.50);
          top: 8px;
          left: 12px;
          z-index: -1;
          transition: .15s all ease-in-out;
          font-family: 'BenchNine', sans-serif;
        }
        input {
          padding: 4px 12px;
          color: rgba(0,0,0,.70);
          border: 1px solid rgba(0,0,0,.12);
          transition: .15s all ease-in-out;
          background: white;
          font-family: 'BenchNine', sans-serif;
          width: calc(100% - (24px + 2px));
          &:focus {
            outline: none;
            transform: scale(1.05);
            & + label  {
              font-size: 13px;
              transform: translateY(-24px) translateX(-12px);
            }
          }
          &::-webkit-input-placeholder {
              font-size: 15px;
              color: rgba(0,0,0,.50);
              font-weight: 100;
          }
        }
    }
    .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .notifList{
        margin-bottom: 5px;
        padding-bottom: 5px;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
</style>